import React from "react";
import {pad} from "../utils";


export default class Main extends React.Component {
    constructor() {
        super();
        
        this.state = {
            loading: true, // New code 20190426... /Russlan
            total: 0,
            progress: 0,
            visibleRooms: [],
        };
    }

    componentDidMount() {
        this.loadWidget();

        this.setState({
            stylePath: this.props.params.widget + '.css'
        });
    }

    componentDidUpdate(prevProps) {
        let oldId = prevProps.params.widget;
        let newId = this.props.params.widget;
        if (newId !== oldId) {
            this.loadWidget();
        }
    }

    loadWidget() {
        this.setState({loading: true}); // New code 20190426... /Russlan
        fetch(`${process.env.REACT_APP_API_URL}/${this.props.params.widget}`)
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.sunstudies) {
                    this.preloadSunstudies(responseJson.sunstudies.data).then(done => {
                        // Setting the value of state's occur twice ??!! ... some where else you can find that happen even more than twice ... feels like redundancy ... here is the second time ... do we need that? // Russlan
                        this.setState({ data: responseJson });
                    });
                }

                // Setting the value of state's occur twice ??!! ... here is the first one
                this.setState({ data: responseJson });
            });
    }

    render() {
        // Old code 20190426... /Russlan
        // if (!this.state.data) {
        //     const progressStyle = {
        //         width: ((this.state.progress / this.state.total) * 100) + '%'
        //     };

        //     return (<div className="cw-main-loader">
        //         <p>Laddar</p>
        //         <div className="progress">
        //             <div className="progress-bar" style={progressStyle} role="progressbar"
        //                  aria-valuenow={this.state.progress} aria-valuemin="0" aria-valuemax={this.state.total}></div>
        //         </div>
        //     </div>);
        // }

        // New code 20190426... /Russlan
        const showProgressBar = (this.state.loading === true);
        const progressPercentage = ((this.state.progress / this.state.total) * 100) + '%';        
        const progressBarStyle = { width: progressPercentage };
        const progressBarComponent = (<div className="cw-progress-bar-container"><div className="progress"><div className="progress-bar" style={progressBarStyle} role="progressbar" aria-valuenow={this.state.progress} aria-valuemin="0" aria-valuemax={this.state.total}></div> </div></div>);

        if (!this.state.data) {                
            return (<div className="cw-main-loader"><p>Laddar...</p><div className="loader"></div></div>);
            
        }

        const childrenWithProps = React.Children.map(this.props.children,
            (child) => React.cloneElement(child, {
                data: this.state.data
            })
        );

        const stylePath = `/templates/${this.state.data.template}/css/style.css`;

        // Old code 20190426... /Russlan
        // return (
        //     <div className="cw-main">
        //         <link rel="stylesheet" type="text/css" href={stylePath}/>
        //         {childrenWithProps}
        //     </div>)

        // New code 20190426... /Russlan
        return (
            <div className="cw-main">            
                <link rel="stylesheet" type="text/css" href={stylePath}/>
                {(showProgressBar === true) && (progressBarComponent)}
                {childrenWithProps}
            </div>)    
    }


    preloadSunstudies(sunstudies) {
        return new Promise((resolve, reject) => {

            let promises = [];

            sunstudies.forEach(sunstudy => {
                sunstudy.views.data.forEach(date => {
                    // Old code 20190426... /Russlan
                    //for (let i = 1; i <= date.image_count-1; i++) {
                    // New code 20190426... /Russlan
                    for (let i = 0; i < date.image_count; i++) {
                        const num = pad('0000', i, true);
                        const url = `${`${date.base_url}/${num}.jpg`}`;

                        promises.push(new Promise((imgResolve, imgReject) => {
                            let image = new Image();
                            image.addEventListener("load", () => {
                                imgResolve();
                                this.setState((prevState, props) => ({
                                    progress: prevState.progress + 1
                                }));
                            }, false);
                            image.src = url;
                        }));
                    }

                    this.setState((prevState, props) => ({
                        // Old code 20190426... /Russlan
                        //total: prevState.total + date.nImages
                        // New code 20190426... /Russlan
                        total: prevState.total + date.image_count
                    }));
                });
            });

            resolve();

            Promise.all(promises).then(values => {
                // New code 20190426 ... /Russlan
                this.setState((prevState, props) => { return { loading: false }; });
                resolve();
            })
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/Main.jsx